import { FormModalWrapper } from '@duke-hq/ui/components/Modals/FormModalWrapper';
import { UpdateEnrolmentForm } from './UpdateEnrolmentForm';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { Center, Spinner } from '@chakra-ui/react';

type UpdateEnrolmentModalProps = {
  isOpen: boolean;
  onClose: () => void;
  enrolmentId: number;
};

export function UpdateEnrolmentModal({ isOpen, onClose, enrolmentId }: UpdateEnrolmentModalProps) {
  const { data: enrolment, isLoading } = trpcAdmin.enrolment.byIdWithResourceStatus.useQuery(
    { enrolmentId },
    {
      enabled: isOpen,
    },
  );

  return (
    <FormModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      modalContent={
        isLoading || !enrolment ? (
          <Center h="400px">
            <Spinner size="lg" />
          </Center>
        ) : (
          <UpdateEnrolmentForm enrolment={enrolment} onClose={onClose} />
        )
      }
    />
  );
}
